const DAILYRENT_BANNER_CONTAINER_ID = 'dailyrent-banner';

export interface IParseDailyrentBanner {
  /** HTML-контент без маркеров */
  html: string;
  /** Id контейнера, в который монтируется DailyrentBanner, если баннер показывается */
  containerId: string | null;
}

/**
 * Обрабатывает маркер `<div data-name="dailyrent-banner"></div>`, который редактор
 * вставляет в текст статьи:
 * - при isEnabled первый маркер заменяется пустым контейнером с id для баннера;
 * - остальные маркеры (и все маркеры при выключенном баннере) вырезаются,
 *   чтобы не оставлять пустого места в статье
 */
export const parseDailyrentBanner = (html: string, isEnabled: boolean): IParseDailyrentBanner => {
  const pattern = /<div[^>]*?(?:data-name="dailyrent-banner")[^>]*?>\s*<\/div>/gis;
  let containerId: string | null = null;

  if (!html) {
    return { html: '', containerId };
  }

  const preparedHtml = html.replace(pattern, () => {
    if (!isEnabled || containerId) {
      return '';
    }

    containerId = DAILYRENT_BANNER_CONTAINER_ID;

    return `<div id="${containerId}"></div>`;
  });

  return { html: preparedHtml, containerId };
};
